import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Machines from "../screens/machines";
import MachineForm from "../screens/machines/machine-form";
import Stores from "../screens/stores";
import CommentForm from "../screens/stores/comment-form";
import Page from "../components/page";
import MachineHistory from "../screens/machines/machine-history";
import Login from "../screens/login";
import SavedForms from "../screens/saved-forms";
import ScannerScreen from "../screens/scanner-screen";
import Dialog from "../components/dialog";

export default function(props) {
  return (
    <BrowserRouter
      getUserConfirmation={(message, callback) => {
        console.log(message);

        const withCleanup = answer => {
          ReactDOM.unmountComponentAtNode(modal);
          document.body.removeChild(modal);
          callback(answer);
        };

        const modal = document.createElement("div");

        document.body.appendChild(modal);
        ReactDOM.render(
          <Dialog close={() => withCleanup(false)}>
            <div>
              <p>You are leaving this page, continue?</p>
              <div className="split-button-container">
                <button onClick={() => withCleanup(true)}>Yes</button>
                <button onClick={() => withCleanup(false)}>No</button>
              </div>
            </div>
          </Dialog>,
          modal
        );
      }}
    >
      <Page>
        {props.children}
        <Switch>
          <Route path="/login" component={Login} />
          <Route
            path="/machine-form/:machine_id/:form_id?"
            component={MachineForm}
          />
          <Route
            exact={true}
            path="/comment-form/:store_id/:comment_id"
            component={CommentForm}
          />
          <Route path="/comment-form/:store_id?" component={CommentForm} />

          <Route path="/machines/:store_id?" component={Machines} />
          <Route path="/stores/:store_id?" component={Stores} />
          <Route
            path="/machine-history/:machine_id"
            component={MachineHistory}
          />
          <Route path="/barcode-scanner" component={ScannerScreen} />
          <Route path="/saved-forms" component={SavedForms} />
          <Route path="/*" component={() => <Redirect to="/login" />} />
        </Switch>
      </Page>
    </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/router/index.js